export default function fillGapsDate(data) {
  if (!data.length) return data

  const dataRestructed = {}
  data.forEach(item => {
    dataRestructed[item.date] = item.data
  })

  const result = []
  const stopDateStr = data[data.length - 1].date // "YYYY-MM-01"

  let year = 2009
  let month = 1

  while (true) {
    const mm = month < 10 ? `0${month}` : `${month}`
    const dateStr = `${year}-${mm}-01`

    if (dateStr > stopDateStr) break

    result.push({
      date: dateStr,
      data: dataRestructed[dateStr] || null,
    })

    month++
    if (month > 12) {
      month = 1
      year++
    }
  }

  return result
}
